import React from 'react';
import styled from 'styled-components';
import { Button } from './buttons';
import Icons from './icons';
import colors from '../helpers/colors';
import MobileTopBarValidator from '../validators/mobileTopBar.validator';

const TopBarWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MobileTopBar = ({ toggleNavigation }) => (
  <TopBarWrapper>
    <Icons.Hamburger fill={colors.blue} onClick={toggleNavigation} />
    <Button color={colors.blue} text={"John Doe"} />
  </TopBarWrapper>
);

MobileTopBar.propTypes = MobileTopBarValidator.MobileTopBarSchema;

export default MobileTopBar;
